import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'metricDistanceUnits'})
export class MetricDistanceUnitsPipe implements PipeTransform {
  transform(isMetricUnits: boolean): string {
    const km = $localize`km`;
    const mi = $localize`mi`;
    return isMetricUnits ? `1.6K ${km}` : `1K ${mi}`;
  }
}